import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

const LoginPage = () => {
  const navigate = useNavigate();
  // const { login } = useAuth();
  const { login, user, loading } = useAuth(); // ✅ Agregar user y loading

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  // const [loading, setLoading] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false); // ✅ Renombrar para evitar conflicto

const [showPassword, setShowPassword] = useState(false);
  // ✅ NUEVO: Redirigir si ya está logueado
  useEffect(() => {
    if (!loading && user) {
      // console.log('👤 Usuario ya logueado, redirigiendo...'); // ✅ DEBUG
      if (user.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/mi-cuenta', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}, []);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoadingForm(true); // ✅ Usar loadingForm en lugar de loading

    try {
      const result = await login(formData.email, formData.password);
      
      if (result.success) {
        // ✅ La redirección ahora la maneja el useEffect de arriba
        // console.log('✅ Login exitoso, el useEffect redirigirá...'); // ✅ DEBUG
      } else {
        setError(result.error || 'Error al iniciar sesión');
      }
    } catch (err) {
      setError('Error al iniciar sesión. Por favor intentá de nuevo.');
    } finally {
      setLoadingForm(false);
    }
  };

  // ✅ Mostrar spinner mientras verifica el estado de auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50 flex flex-col">
      {/* Header */}
      {/* <header className="bg-white shadow-sm border-b border-neutral-200"> */}
        <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          {/* <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl">💝</span>
            <span className="text-2xl font-script font-bold text-accent-600">
              SobreDigital
            </span>
          </Link> */}
                <Logo className="h-12 sm:h-14" />


        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-xl p-8 animate-scale-in">
            {/* Title */}
            <div className="text-center mb-8">
              <h2 className="text-3xl font-display font-bold text-neutral-900 mb-2">
                ¡Bienvenid@s!
              </h2>
              <p className="text-neutral-600">
                Ingresá a tu cuenta para gestionar tu lista
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            {/* Login Form */}
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="input-field"
                  placeholder="tu@email.com"
                />
              </div>

         
<div>
  <label className="block text-sm font-medium text-neutral-700 mb-2">
    Contraseña
  </label>

  <div className="relative">
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      value={formData.password}
      onChange={handleChange}
      required
      className="input-field pr-12"
      placeholder="••••••••"
    />

    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
      aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
    >
      {showPassword ? (
        // 👁️‍🗨️ Ojo abierto
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
               -1.274 4.057-5.064 7-9.542 7
               -4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      ) : (
        // 🚫 Ojo tachado
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M13.875 18.825A10.05 10.05 0 0112 19
               c-4.478 0-8.268-2.943-9.542-7
               a9.956 9.956 0 012.041-3.368M6.223 6.223
               A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7
               a9.978 9.978 0 01-4.132 5.411M15 12a3 3 0 00-3-3" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M3 3l18 18" />
        </svg>
      )}
    </button>
  </div>
</div>
              <div className="flex items-center justify-between text-sm">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="rounded border-neutral-300 text-accent-600 focus:ring-accent-500"
                  />
                  <span className="ml-2 text-neutral-600">Recordarme</span>
                </label>
                <Link to="/forgot-password" className="text-accent-600 hover:text-accent-700 font-medium">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>

              <button
                type="submit"
                disabled={loadingForm}
                className="w-full btn-primary text-lg"
              >
                {loadingForm ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Ingresando...
                  </span>
                ) : (
                  'Iniciar Sesión'
                )}
              </button>
            </form>

            {/* Demo Credentials */}
            {/* <div className="mt-6 p-4 bg-accent-50 rounded-lg border border-accent-200">
              <p className="text-sm font-semibold text-accent-900 mb-2">Demo - Credenciales de prueba:</p>
              <div className="text-xs text-accent-800 space-y-1">
                <p><strong>Admin:</strong> admin@admin.com / admin123</p>
                <p><strong>Pareja:</strong> maria@email.com / maria123</p>
              </div>
            </div> */}

            {/* Register Link */}
            <div className="mt-6 text-center">
              <p className="text-neutral-600 text-sm">
                ¿No tenés cuenta?{' '}
                <Link to="/register" className="text-accent-600 hover:text-accent-700 font-semibold">
                  Registrate gratis
                </Link>
              </p>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-6 text-center">
            <Link to="/" className="text-neutral-600 hover:text-neutral-900 text-sm font-medium">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
